<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ "updateAvailability.listAvailability.title" | translate }}
      <b>{{ startDate | localizedDate }}</b>
      {{ "updateAvailability.listAvailability.until" | translate }}
      <b>{{ endDate | localizedDate }}</b>
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ advertisingCampaign.title }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div *ngFor="let cost of totalPrice" class="mb-3">
    <b>{{ cost.availabilities.companyName }}</b>
    <span
      class="m-l-10"
      [ngClass]="
        'badge ' +
        badgeService.getBadgeForLocationPartnerAvailability(
          cost.availabilities.availabilityStatus
        )
      "
    >
      {{
        badgeService.getLabelKeyForLocationPartnerAvailability(
          cost.availabilities.availabilityStatus
        ) | translate
      }}
    </span>
    <div
      *ngFor="
        let availability of cost.availabilities
          .listOfUnpaidBookingIntervals;
        let i = index
      "
    >
      <div class="form-check checkbox checkbox-primary mb-0">
        <input
          [id]="cost.availabilities.companyName + i"
          type="checkbox"
          name="rdo-ani"
          class="form-check-input"
          [checked]="
            isPeriodChecked(
              cost.availabilities.companyName,
              availability
            )
          "
          (change)="
            saveAvailability(
              $event,
              availability,
              cost.availabilities
            )
          "
        />
        <label
          class="form-check-label label"
          [for]="cost.availabilities.companyName + i"
          >{{ availability.startDate | localizedDate }} to
          {{ availability.endDate | localizedDate }}</label
        >
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    data-bs-dismiss="modal"
    (click)="close()"
  >
    {{ "buttons.close" | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="saveChanges()"
    [disabled]="selectedPeriod.length === 0"
  >
    <loading-button [value]="'buttons.apply'" [icon]="null"></loading-button>
  </button>
</div>
